"use client";
import type { UseFlightSearchFormProperties } from "./hooks/use-flight-search-form";
import { useFlightSearchForm } from "./hooks/use-flight-search-form";
import { StatelessFlightSearchForm } from "./stateless";

export type FlightSearchFormProperties = UseFlightSearchFormProperties;
export const FlightSearchForm = (properties: FlightSearchFormProperties) => (
  <StatelessFlightSearchForm {...useFlightSearchForm(properties)} />
);
